import { GetterTree } from "vuex";
import { RootState } from "../types/RootState";
import {ProgramState} from "../types/ProgramState";
import {Element} from "@api/models/Element";
import {ProgramDataHelper} from "@share/program/helpers/ProgramDataHelper";
import {DateTime} from "luxon";
import {dateInOriginalOffset} from "@common/dateTimeHelper";
import { COMINGSOON_PERIOD_IN_MINUTES } from "@common/constants";

const getters: GetterTree<ProgramState, RootState> = {
    dataHelperByDate: (state, getters, rootState) => (date: DateTime) => {
      const dateStr = dateInOriginalOffset(date, rootState.timeZoneOffset as number || 0).toISODate();
      return state.programs[dateStr] || null;
    },
    dataHelperByAgendaId: state => (id: string) => {
        const programs = Object.values(state.programs);
        let dataHelper: ProgramDataHelper | undefined = undefined;

        for(let i = 0, len = programs.length; i < len; i++) {
            const index = programs[i].allAgendas.findIndex((meeting) => {
                return meeting.id == id;
            })
            if (index >= 0) {
                dataHelper = programs[i];
                break;
            }
        }
        return dataHelper;
    },
    nextSession: (state, getters) => (currentSessionId: string): Element | undefined => {
        const dataHelper = getters['dataHelperByDate'](DateTime.local());

        if (dataHelper === null) {
            return undefined;
        }

        const agendas = dataHelper.agendas
            .filter((agenda: Element) => {
                return DateTime.fromISO(agenda.beginAt) > DateTime.local().minus({ minutes: COMINGSOON_PERIOD_IN_MINUTES }) && agenda.id !== currentSessionId;
            })
            .sort((a: Element, b: Element) => {
                if (a.beginAt > b.beginAt) {
                    return 1;
                }
                if (a.beginAt < b.beginAt) {
                    return -1
                }
                return 0;
            })

        return agendas.shift();
    },
    currentDateString(state, getters, rootState) {
        if (state.currentDate) {
            return dateInOriginalOffset(state.currentDate, (rootState as any).timeZoneOffset).toISODate();
        }
        else {
            return "";
        }

    },
    currentProgramSessionList: (state, getters) => {
        if (getters.currentDateString) {
            const dataHelper = state.programs[getters.currentDateString];

            let agendas = dataHelper?.agendaResource ? dataHelper.agendaResource : [];

            return agendas.sort((a, b) => {
                if (a.beginAt > b.beginAt) {
                    return 1;
                }
                if (a.beginAt < b.beginAt) {
                    return -1
                }
                return 0;
            })
        }
        else {
            return []
        }
    }
};

export { getters }
